import { render, staticRenderFns } from "./TwoStateIcon.vue?vue&type=template&id=7ae64035&"
import script from "./TwoStateIcon.vue?vue&type=script&lang=js&"
export * from "./TwoStateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports